// 派单规则
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane :label="$t('common.routine')" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></editView>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.list')" name="second">
        <div class="grid-height" style="height: calc(100vh - -65px);">
          <vxe-grid
            ref="table-m1" v-bind="vxeOption"
            :checkbox-config="{ labelField: '', highlight: true, reserve: true , range: true}"
            @checkbox-all="selectAllEvent"
            @checkbox-change="selectChangeEvent"

            show-overflow height="100%" border="default" :stripe="true" :row-config="{ isHover: true }"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button v-if="snAutoDispatchAdd" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">{{$t('common.New')}}
                  </vxe-button>
                  <vxe-button v-if="snAutoDispatchDelete" status="primary" class="button-sty" icon="el-icon-delete"
                              @click="handleDeleteList">{{$t('common.BatchDeletion')}}
                  </vxe-button>
                  <vxe-button v-if="snAutoDispatchDeleteByCondition" status="primary" class="button-sty" icon="el-icon-delete"
                              @click="deleteByCondition">{{$t('common.deleteByCondition')}}
                  </vxe-button>
                </div>
                <div class="fr">
                  <!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
                  <!--                              status="primary" plain>重置-->
                  <!--                  </vxe-button>-->
                  <vxe-button  status="warning" icon="el-icon-search" class="button-sty"
                               @click="searchEvent">{{$t('common.search')}}
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
                        @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">

                <vxe-form-item :title="$t('common.ServiceNetwork')+':'" field="name">
                  <template v-slot>
                    <site-search :site-id.sync="formData.siteId"
                                 :show="!currentIsSite"
                                 :show-site-name.sync="formData.siteName"
                                 style="width: 11vw"
                    />
                  </template>
                </vxe-form-item>

                <vxe-form-item :title="$t('common.ServiceBrand')+':'" field="name">
                  <template v-slot>
                    <brand-select :brand-id.sync="formData.brandId" :brand-name.sync="formData.brandName"  />
                  </template>
                </vxe-form-item>

                <vxe-form-item :title="$t('common.ProductCategory')+':'" field="name">
                  <template v-slot>
                    <el-select v-model="formData.bigCategoryId"  @change='selectOne'   clearable>
                      <el-option v-for="item in productOptions0" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </vxe-form-item>

                <vxe-form-item :title="$t('common.ProductSubclass')+':'" field="name">
                  <template v-slot>
                    <el-select v-model="formData.smallCategoryId"    clearable>
                      <el-option v-for="item in productOptions1" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </vxe-form-item>

                <vxe-form-item :title="$t('common.ServiceType')+':'" field="name">
                  <template v-slot>
                    <service-type-cascader  @selectedServiceType="data => {formData.serviceTypeId = data}" style="width: 11vw"/>
                  </template>
                </vxe-form-item>

                <vxe-form-item :title="$t('common.PurchaseChannel')+':'" field="name">
                  <template v-slot>
                    <el-select v-model="formData.buyChannelId"    clearable>
                      <el-option v-for="item in buyChannelOption" :key="item.buyChannelName"
                                 :label="item.buyChannelName" :value="item.id" />
                    </el-select>
                  </template>
                </vxe-form-item>

                <vxe-form-item :title="$t('common.district')+':'" field="name" >
                  <template v-slot>
                    <!--                    <el-input v-model="formData.areaId" size="small" clearable/>-->
                    <el-cascader   :props="areaProps" v-model="formData.areaId" :clearable="true"
                                   @change="handleChange" ref="cascaderAddr" >
                    </el-cascader>
                  </template>
                </vxe-form-item>

              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import {tableOption} from '@/const/crud/admin/tenant';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import request from "@/router/axios";
import {mapGetters} from "vuex";
import BrandSelect from "@/components/formItem/brandSelect.vue";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import api from "@/api/projectApi";
import store from "@/store";
import {fetchTree} from "@/api/admin/type_tree";
import ServiceTypeCascader from "@/components/formItem/serviceTypeCascader.vue";
import {siteMixins} from "@/mixins/tabChang";

export default {
  name: 'send',
  inject: ['reload'],
  mixins: [siteMixins],
  components: {BrandSelect, editView, pager,SiteSearch,ServiceTypeCascader},
  data() {
    return {
      total: 0,
      getListPageUrl: '/basic/snAutoDispatch/getListPage',
      deleteDataUrl: '/basic/snAutoDispatch/delete',
      deleteByConditionUrl: '/basic/snAutoDispatch/deleteByCondition',
      getBrandListUrl: '/basic/snCompanyBrand/getBrandList',
      getAreaDataUrl: '/basic/basArea/getList',
      //权限
      snAutoDispatchAdd:false,
      snAutoDispatchDelete:false,
      snAutoDispatchDeleteByCondition: false,
      productOptions0: [],
      productOptions1: [],
      requestParam: {
        siteId: null,
        siteName: '',
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        beginDate: '',
        endDate: '',
        areaId: '',
        brandId: '',
        brandName: '',
        serviceTypeId: null,
        buyChannelId: null,
        buyChannelName: '',
        bigCategoryId: null,
        smallCategoryId: null,
      },

      brandOptions: [],
      selectionRows: [],
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },

      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      searchDate: null,
      formData: {
        siteId: null,
        siteName: null,
        brandId: '',
        beginDate: '',
        endDate: '',
        areaId: '',
        serviceTypeId: '',
        bigCategoryId: null,
        smallCategoryId: null,
        buyChannelId: null,
      },
      pageSizes: [10, 20, 100],
      columns: [
        {type: "checkbox", title: '', width: 60, resizable: false,},
        {title: this.$t('common.ServiceNetwork'), field: 'siteName', width: 130,},
        // {title: '网点编码', field: 'siteCode', width: 150,},
        {title: this.$t('common.ServiceType'), field: 'serviceTypeName', width: 130,},
        {title: this.$t('common.ServiceBrand'), field: 'brandName', width: 110,},
        {title: this.$t('common.district'), field: 'areaName', width: 300,},
        {title: this.$t('common.ProductCategory'), field: 'bigCategoryName', width: 130,},
        {title: this.$t('common.ProductSubclass'), field: 'smallCategoryName', width: 130,},
        {title: this.$t('common.PurchaseChannel'), field: 'buyChannelName', width: 130,},
        {field: 'beginDate', title: this.$t('send.BeginDate'), width: 120},
        {field: 'endDate', title: this.$t('send.EndDate'), width: 120},
        {field: 'createTime', title: this.$t('common.CreationTime'), width: 150},
        {title: this.$t('common.founder'), field: 'createBy', width: 150,},
        {width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              if (this.snAutoDispatchDelete){
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.handleDelete(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="删除" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-delete"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        }
      ]
    };
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.snAutoDispatchAdd= this.permissions["snAutoDispatchAdd"];
    this.snAutoDispatchDelete = this.permissions["snAutoDispatchDelete"];
    this.snAutoDispatchDeleteByCondition = this.permissions["snAutoDispatchDeleteByCondition"];
  },
  mounted() {
    this.loadBrandOption()
    this.loadProductOption0();
    this.loadServiceTypeOptions()
    this.loadBuyChannelOptions()
  },
  methods: {
    toFilterData() {
      this.searchEvent();
    },
    setSiteData() {
      this.formData.siteName = this.currentSiteData.userName
    },

    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: this.getBrandListUrl,
        method: 'post',
        data: {
          // usable: 1  // 加载启用的
        }
      }).then(res => {
        this.brandOptions = []
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },

    // 加载服务类型
    loadServiceTypeOptions() {
      this.$http({
        url: api.basServiceType.getOptionUrl,
        method: 'post',
        data: {}
      }).then(res => {
        // console.log(res.data.data, 'option')
        let list = [{value: null, label: '全部'}]
        res.data.data.forEach(item => {
          if (item.children.length == 0) {
            delete item.children
          }
          list.push(item)
        })
        this.serviceTypeOption = list
      })
    },

    //加载购买渠道
    loadBuyChannelOptions() {
      this.$http({
        url: api.basBuyChannel.getListDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.buyChannelOption = res.data.data
        console.log("buyChannelOption",this.buyChannelOption)
      })
    },

    serviceTypeHandleChange(data) {
      console.log('选中的服务类型数据', data)
    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      request({
        url: this.getAreaDataUrl,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        const childrens = response.data.objx || {};
        const nodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) > 0
        }))
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      })
    },

    // 地址三级联动
    handleChange() {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      this.formData.areaId = areaNode[0].value
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },


    // 批量删除
    handleDeleteList() {
      if (this.selectionRows.length === 0) {
        this.$message.warning('请先勾选数据')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.$http({
            url: this.deleteDataUrl,
            method: 'post',
            data: {
              deleteIdList: this.selectionRows
            }
          }).then(res => {
            this.$message.success('删除成功')
            // this.reload()
            this.searchEvent();
          })
        })
      }
    },

    // 根据条件删除
    deleteByCondition() {
      this.requestParam.siteId = this.formData.siteId
      this.requestParam.siteName = this.formData.siteName
      this.requestParam.brandId = this.formData.brandId
      this.requestParam.brandName = this.formData.brandName
      this.requestParam.areaId = this.formData.areaId
      // this.requestParam.areaName = this.formData.areaName
      if (this.searchDate && this.searchDate.length === 2) {
        this.requestParam.beginDate = this.searchDate[0]
        this.requestParam.endDate = this.searchDate[1]
      } else {
        this.requestParam.beginDate = null
        this.requestParam.endDate = null
      }

      this.requestParam.serviceTypeId = this.formData.serviceTypeId

      this.requestParam.bigCategoryId = this.formData.bigCategoryId
      this.requestParam.smallCategoryId = this.formData.smallCategoryId
      this.requestParam.buyChannelId = this.formData.buyChannelId

      console.log("1111111111")
      let hasCondition = false
      // if (!this.requestParam.siteId) {
      //   this.$message.error('服务商必填,才允许删除!!')
      //   return false;
      // }
      let conditionStr = ''
      if (this.requestParam.siteId) {
        hasCondition = true
        conditionStr += '\n 服务商 '
      }
      if (this.requestParam.brandId) {
        hasCondition = true
        conditionStr += '\n 品牌: ' + this.requestParam.brandName
      }
      if (this.requestParam.bigCategoryId) {
        hasCondition = true
        conditionStr += '\n 大类 '
      }
      if (this.requestParam.smallCategoryId) {
        hasCondition = true
        conditionStr += '\n 小类 '
      }
      // if (this.requestParam.beginDate) {
      //   hasCondition = true
      //   conditionStr += '\n 开始时间 '
      // }
      // if (this.requestParam.endDate) {
      //   hasCondition = true
      //   conditionStr += '\n 结束时间 '
      // }
      if (this.requestParam.serviceTypeId) {
        hasCondition = true
        conditionStr += '\n 服务类型 '
      }
      if (this.requestParam.buyChannelId) {
        hasCondition = true

        if (this.requestParam.buyChannelId) {
          this.buyChannelOption.forEach(item => {
            if (this.requestParam.buyChannelId === item.id) {
              this.requestParam.buyChannelName = item.buyChannelName
            }
          })
        }
        conditionStr += '\n 购买商场: ' + this.requestParam.buyChannelName
      }
      if (this.requestParam.areaId) {
        hasCondition = true
        conditionStr += '\n 区域 '
      }
      if (!hasCondition) {
        this.$message.error('无条件不允许删除!!')
        return false;
      }
      this.$baseConfirm('请注意,当前为根据当前条件删除派单规则!!!是否确认根据当前条件删除数据? \n 已选: (' + conditionStr + ')条件').then(() => {
        this.$http({
          url: this.deleteByConditionUrl,
          method: 'post',
          data: this.requestParam,
        }).then(res => {
          this.$message.success('删除成功')
          this.searchEvent();
        })
      })
    },

    // 单个删除
    handleDelete(id) {
      console.log(id)
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.$http({
          url: this.deleteDataUrl,
          method: 'post',
          data: {
            deleteIdList: [id]
          }
        }).then(res => {
          this.$message.success('删除成功')
          this.flushed()
        })
      })
    },

    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    //全选
    selectAllEvent({checked, records, reserves}) {
      this.selectionRows = records.map(item => item.id)
      console.log(this.selectionRows)
    },

    //单个选中
    selectChangeEvent(data) {
      if (data.checked) {
        this.selectionRows.push(data.row.id)
      } else {
        this.selectionRows = this.selectionRows.filter(item => item !== data.row.id)
      }
      console.log(this.selectionRows)
    },

    // 搜索
    searchEvent() {
      this.requestParam.siteId = this.formData.siteId
      this.requestParam.siteName = this.formData.siteName

      this.requestParam.brandId = this.formData.brandId
      this.requestParam.areaId = this.formData.areaId
      if (this.searchDate && this.searchDate.length === 2) {
        this.requestParam.beginDate = this.searchDate[0]
        this.requestParam.endDate = this.searchDate[1]
      } else {
        this.requestParam.beginDate = null
        this.requestParam.endDate = null
      }

      this.requestParam.serviceTypeId = this.formData.serviceTypeId

      this.requestParam.bigCategoryId = this.formData.bigCategoryId
      this.requestParam.smallCategoryId = this.formData.smallCategoryId
      this.requestParam.buyChannelId = this.formData.buyChannelId

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.formData = {
        brandId: '',
        beginDate: '',
        endDate: '',
        areaId: '',
        serviceTypeId: ''
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.areaId = ''
      this.requestParam.serviceTypeId = ''
      this.requestParam.brandId = ''
      this.requestParam.beginDate = ''
      this.requestParam.endDate = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true
      this.activeName = 'second';
      this.flushed()


    },

    // 加载产品大类
    loadProductOption0() {
      fetchTree({
        categoryType: 1,
        usable: 1
      }).then(response => {
        this.productOptions0 = []
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },

    // 加载产品小类
    loadProductOption1() {
      fetchTree({
        categoryType: 1,
        usable: 1,
        parentId: this.formData.bigCategoryId
      }).then(response => {
        this.productOptions1 = []
        response.data.data.forEach(item => {
          this.productOptions1.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },

    // 选中产品大类加载小类
    selectOne() {
      this.formData.smallCategoryId = ''
      this.loadProductOption1()
    },

    // 新增
    openEditDialog(id) {
      console.log(id,);
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
      // this.vxeOption.splice(index, 1);
    },

  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }

  ::v-deep .el-cascader--medium {
    width: 13vw;
    height: 38px;
  }

  ::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
    -webkit-box-flex: 1;
    display: inline-block;
    width: 55px;
    -ms-flex-positive: 1;
    flex-grow: 1;
  }

  ::v-deep .el-select>.el-input {
    width: 13vw;
  }

  ::v-deep .vxe-grid .el-input .el-input__inner {
    height: 28px !important;
  }

  // 隐藏搜索框 标题的宽度
  ::v-deep .vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
    font-size: 12px;
    display: inline-block;
    width: 65px !important;
  }
}
::v-deep .tab-box .vxe-grid .vxe-form--item .vxe-form--item-title {
  font-size: 12px;
  display: inline-block;
  width: 60px!important;
}
.vxe-grid .vxe-form--item .vxe-form--item-title {
  width: 5vw !important;
  margin-left: 16px;
}
</style>
